import { gql } from '@apollo/client';

export const GET_BREADCRUMBS = gql`
    query getUserBreadcrumbs($input: String!) {
        getUserBreadcrumbs(input: $input) {
            action
            createdAt
        }
    }
`;
